import { PersonalityAnalysisDetail } from '@aibees/elephant/components/personality-analysis-detail';
import { contentRendererMap } from '@aibees/elephant/components/personality-analysis-detail/config';
import { usePersonReadDataContext } from '@aibees/elephant/context';
import { PersonCard } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/person-card';
import { PersonalityAnalysisTabTitle } from '@aibees/elephant/types/personality-analysis';
import { Grid2 } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Divider, Stack, Typography } from '@mui/material';
import { createElement, memo, useState } from 'react';
import { AiAnalysisProfileCards } from '../ai-analysis-profile-cards';
import { EntityInfoPanel } from '../entity-info-panel';
import { OverviewCard } from '../overview-personality/components/overview-card';
import { OverviewDescription } from '../overview-personality/components/overview-description';
import { OverviewHeader } from '../overview-personality/components/overview-header';
import { PeopleAnalysisBlurOverlay } from '../people-analysis-blur-overlay';
import { TruncatedText } from '../truncated-text';
import * as Styled from './styles';
import * as SX from './sx';
import type { SidebarPersonalityAnalysisProps as Props } from './types';

export const SidebarPersonalityAnalysis = memo(({ className }: Props) => {
  const { api } = usePersonReadDataContext();

  const [currentTab, setCurrentTab] = useState<string>(
    PersonalityAnalysisTabTitle.SALES_ANALYSIS
  );

  return (
    <Styled.Wrapper
      className={classnames('SidebarPersonalityAnalysis', className)}
      sx={SX.root}
    >
      <PeopleAnalysisBlurOverlay isSidebar>
        <Stack p={1.5}>
          <PersonCard />
        </Stack>
        <Divider />
        {api?.data?.profile?.summary && (
          <>
            <Stack gap={1} p={1.5}>
              <Typography variant="body3" fontWeight={700} color="grey.700">
                People Overview :
              </Typography>

              <TruncatedText
                expandMode="button"
                text={api?.data?.profile?.summary}
                typographyProps={{ variant: 'body4' }}
              />
            </Stack>
            <Divider />
          </>
        )}
        <Stack p={1} gap={1}>
          <Grid2 sx={SX.headerItem}>
            <EntityInfoPanel
              title="Overview Personality"
              icon="dashboard-outline"
            >
              <Stack p={1.5} gap={1.5}>
                <OverviewHeader isSidebar />
                <AiAnalysisProfileCards />
                <OverviewCard isSidebar />
                <OverviewDescription isSidebar />
              </Stack>
            </EntityInfoPanel>

            <PersonalityAnalysisDetail isSidebar onChange={setCurrentTab} />
          </Grid2>
          <Grid2 sx={SX.content}>
            {createElement((contentRendererMap as any)[currentTab], {
              isSidebar: true,
            })}
          </Grid2>
        </Stack>
      </PeopleAnalysisBlurOverlay>
    </Styled.Wrapper>
  );
});

SidebarPersonalityAnalysis.displayName = 'SidebarPersonalityAnalysis';
